import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch, useMutation } from '../api';

type GetSshKeys = ApiClient['v2']['devices'][':deviceId']['ssh-keys']['$get'];
export type SshKeyListResponse = InferResponseType<GetSshKeys, 200>;
export type DeviceSshKey = SshKeyListResponse['deviceSSHKeys'][number];

type AddSshKey = ApiClient['v2']['devices'][':deviceId']['ssh-keys']['$post'];
export type AddSshKeyRequest = InferRequestType<AddSshKey>['json'];

export function useSshKeys(deviceId: number) {
  return useFetch<SshKeyListResponse>(`/devices/${deviceId}/ssh_keys`, (client) =>
    client.v2.devices[':deviceId']['ssh-keys'].$get({
      param: { deviceId: deviceId.toString() },
      query: {},
    })
  );
}

export function useAddSshKeys(deviceId: number, actionOnErr: () => void = () => {}) {
  return useMutation(
    `/devices/${deviceId}/ssh_keys`,
    (client, data: AddSshKeyRequest) =>
      client.v2.devices[':deviceId']['ssh-keys'].$post({
        param: { deviceId: deviceId.toString() },
        json: data,
      }),
    actionOnErr
  );
}

export function useDeleteSshKey(deviceId: number, actionOnErr: () => void = () => {}) {
  return useMutation(
    `/devices/${deviceId}/ssh_keys`,
    (client, sshKeyId: number) =>
      client.v2.devices[':deviceId']['ssh-keys'][':sshKeyId'].$delete({
        param: { deviceId: deviceId.toString(), sshKeyId: sshKeyId.toString() },
      }),
    actionOnErr
  );
}
